import { render, staticRenderFns } from "./ArchivesTopCard.vue?vue&type=template&id=301fcfb7&scoped=true&"
import script from "./ArchivesTopCard.vue?vue&type=script&lang=js&"
export * from "./ArchivesTopCard.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesTopCard.vue?vue&type=style&index=0&id=301fcfb7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301fcfb7",
  null
  
)

export default component.exports